import { WELCOME_TOAST_SHOWN_KEY } from '@features/Auth/Welcome';
import { actions } from '@shared/store/ducks';
import { useAppDispatch } from '@shared/store';
import { useNavigate } from 'react-router-dom';
import { UnauthenticatedPath } from '@shared/constants/routes.constants';

export const useSignOut = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onLogout = () => {
    sessionStorage.removeItem(WELCOME_TOAST_SHOWN_KEY);
    localStorage.removeItem('firstLogin');
    dispatch(actions.auth.signOut());
    navigate(UnauthenticatedPath.SIGN_IN);
  };

  return onLogout;
};
